import React, { FunctionComponent } from 'react';
import { useTheme } from '@rbx/ui';

type TNoNewNotificationsProps = {
  size?: number;
};

const NoNewNotifications: FunctionComponent<TNoNewNotificationsProps> = ({ size }) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.2034 86.9165L48.3634 73.9965C53.8834 72.0365 55.4834 64.9565 51.3234 60.7965L33.2034 42.6765C29.0434 38.5165 22.0034 40.1165 20.0034 45.6365L7.08344 81.7965C5.96344 84.9965 9.00344 88.0365 12.2034 86.9165Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M56.4834 49.7565L76.7234 29.5165C78.6834 27.5565 81.8434 27.5565 83.8034 29.5165L84.0434 29.7565C85.2034 30.9165 87.1234 30.9165 88.2834 29.7565C89.4434 28.5965 89.4434 26.6765 88.2834 25.5165L88.0434 25.2765C83.7634 20.9965 76.7634 20.9965 72.4834 25.2765L52.2434 45.5165C51.0834 46.6765 51.0834 48.5965 52.2434 49.7565C53.4034 50.9165 55.3234 50.9165 56.4834 49.7565Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M36.4834 29.2765L36.2434 29.5165C35.0834 30.6765 35.0834 32.5965 36.2434 33.7565C37.4034 34.9165 39.3234 34.9165 40.4834 33.7565L40.7234 33.5165C45.0034 29.2365 45.0034 22.2365 40.7234 17.9565L40.5234 17.7565C39.3234 16.5565 37.4034 16.5565 36.2434 17.7565C35.0834 18.9165 35.0834 20.8365 36.2434 21.9965L36.4834 22.2365C38.4034 24.1565 38.4034 27.3565 36.4834 29.2765Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M64.4834 49.2765L60.2434 53.5165C59.0834 54.6765 59.0834 56.5965 60.2434 57.7565C61.4034 58.9165 63.3234 58.9165 64.4834 57.7565L68.7234 53.5165C70.6834 51.5565 73.8434 51.5565 75.8034 53.5165L80.1234 57.8365C81.2834 58.9965 83.2034 58.9965 84.3634 57.8365C85.5234 56.6765 85.5234 54.7565 84.3634 53.5965L80.0434 49.2765C75.7234 44.9965 68.7634 44.9965 64.4834 49.2765Z'
        fill={theme.palette.content.muted}
      />
      <path
        d='M56.4834 25.2765L44.2434 37.5165C43.0834 38.6765 43.0834 40.5965 44.2434 41.7565C45.4034 42.9165 47.3234 42.9165 48.4834 41.7565L60.7234 29.5165C65.0034 25.2365 65.0034 18.2365 60.7234 13.9565L56.4834 9.7165C55.3234 8.5565 53.4034 8.5565 52.2434 9.7165C51.0834 10.8765 51.0834 12.7965 52.2434 13.9565L56.4834 18.1965C58.4034 20.1565 58.4034 23.3565 56.4834 25.2765Z'
        fill={theme.palette.content.muted}
      />
    </svg>
  );
};

export default NoNewNotifications;
